import { Grid, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import { IPostcode } from '../../../../../../../Interfaces/IPostcode';
import { ICompany } from '../../../../../../../Interfaces/ICompany';
import PostcodeSearch from '../../../../../../generic/PostcodeSearch';
import { handlePostcode } from '../../../../../../../services/dialog.service';

interface IProps {
  companyObject: ICompany;
  setCompanyObject: Function;
}

const CompanyModifiedBaseInformation: React.FC<IProps> = ({
  companyObject,
  setCompanyObject,
}) => {
  const [postcodeObjectCompany, setPostcodeObjectCompany] = useState<
    IPostcode | null | undefined
  >(handlePostcode(companyObject));

  const setPostcodeObjectCompanyWrapper = (
    postcodeObject: IPostcode | null | undefined
  ) => {
    if (postcodeObject) {
      setCompanyObject({
        ...companyObject,
        idPostcode: postcodeObject.idPostcode,
        Postcode: postcodeObject.Postcode,
        City: postcodeObject.City,
      } as ICompany);
    } else {
      setCompanyObject({
        ...companyObject,
        idPostcode: null,
        Postcode: undefined,
        City: undefined,
      } as ICompany);
    }
    setPostcodeObjectCompany(postcodeObject);
  };

  return (
    <>
      <Typography variant='h6' mb={2}>
        Firmendaten
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            label={'Firma'}
            size='small'
            //error={companyObject.Company === ''}
            required
            fullWidth
            value={companyObject.Company}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setCompanyObject({
                ...companyObject,
                Company: event.target.value,
              })
            }
          />
        </Grid>

        <Grid item xs={4}>
          <TextField
            label='Handelsregisternummer'
            size='small'
            fullWidth
            value={
              companyObject.RegisterNumber === null
                ? ''
                : companyObject.RegisterNumber
            }
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setCompanyObject({
                ...companyObject,
                RegisterNumber:
                  event.target.value === '' ? null : event.target.value,
              })
            }
          />
        </Grid>
        <Grid item xs={8}>
          <TextField
            label='Handelsregistergericht'
            size='small'
            fullWidth
            value={
              companyObject.RegisterCourt === null
                ? ''
                : companyObject.RegisterCourt
            }
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setCompanyObject({
                ...companyObject,
                RegisterCourt:
                  event.target.value === '' ? null : event.target.value,
              })
            }
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            label='Steuernummer'
            size='small'
            fullWidth
            value={
              companyObject.TaxNumber === null ? '' : companyObject.TaxNumber
            }
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setCompanyObject({
                ...companyObject,
                TaxNumber:
                  event.target.value === '' ? null : event.target.value,
              })
            }
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            label='USt-IdNr.'
            size='small'
            fullWidth
            value={
              companyObject.SalesTaxNumber === null
                ? ''
                : companyObject.SalesTaxNumber
            }
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setCompanyObject({
                ...companyObject,
                SalesTaxNumber:
                  event.target.value === '' ? null : event.target.value,
              })
            }
          />
        </Grid>
      </Grid>
      <Typography mb={2} mt={6} variant='h6'>
        Firmensitz
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={8}>
          <TextField
            label={'Straße'}
            size='small'
            fullWidth
            value={companyObject.Street}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setCompanyObject({
                ...companyObject,
                Street: event.target.value,
              })
            }
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            label={'Hausnummer'}
            size='small'
            fullWidth
            value={companyObject.StreetNr}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setCompanyObject({
                ...companyObject,
                StreetNr: event.target.value,
              })
            }
          />
        </Grid>
        <Grid item xs={12}>
          <PostcodeSearch
            key={postcodeObjectCompany?.idPostcode}
            postcodeObject={postcodeObjectCompany}
            setPostcodeObject={setPostcodeObjectCompanyWrapper}
            required={true}
          />
        </Grid>
      </Grid>
    </>
  );
};
export default CompanyModifiedBaseInformation;
